export default __webpack_public_path__ + "static/AndrewGogokhia-d14bb56dce0c2f61ded1db859f5cd4fe.png";